// import { fcmVapidKey } from "config";
import * as firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/messaging';

// Initialize Firebase from .env files
const projectId = process.env.REACT_APP_PROJECT_ID;

var config = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: `${projectId}.firebaseapp.com`,
  databaseURL: `https://${projectId}.firebaseio.com`,
  projectId: projectId,
  storageBucket: `${projectId}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_FB_MSG_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};

firebase.initializeApp(config);

const fcmVapidKey =
  'BCLIp96vWIhnjx1zut0Upl6oBZdD1XMHfwFoQrcSnMGacHvQTBRrwbQD6XBeOHWEJsnG07zKhxZ3woDiTabkoUA';

const messaging = firebase.messaging();
messaging.usePublicVapidKey(fcmVapidKey);

const setUpNotifications = async () => {
  try {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'granted') {
      console.log('Notification permission granted');
      await onPermissionGranted();
    } else if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        console.log('Notification permission granted');
        await onPermissionGranted();
      }
    } else {
      console.log('Notification permission denied');
    }
  } catch (error) {
    console.log(error);
  }
};

const onPermissionGranted = async () => {
  const token = await messaging.getToken();
  console.log('>>>>>>>>>>>> The token', token);
};

// messaging.onBackgroundMessage((payload) => {
//   console.log(
//     '[firebase-messaging-sw.js] Received background message ',
//     payload
//   );
// Customize notification here
// const notificationTitle = 'Background Message Title';
// const notificationOptions = {
//   body: 'Background Message body.',
// };

// self.registration.showNotification(notificationTitle, notificationOptions);
// });

setUpNotifications();

var storage = firebase.storage();

firebase.firestore().settings({});

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

var db = firebase.firestore();

export { db, firebase, googleAuthProvider, storage, firebase as default };
